export default __webpack_public_path__ + "static/media/lideratto.ee7a6a3a.png";